import { render, staticRenderFns } from "./cameraTag.vue?vue&type=template&id=02a7ed3d&"
import script from "./cameraTag.vue?vue&type=script&lang=js&"
export * from "./cameraTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports